// extracted by mini-css-extract-plugin
export default {"searchBlock":"style_searchBlock__nsvjA"};